import * as angular from "angular";
import {ILogService} from "angular";
import {WorkingSlotEntity} from "../models/working-slot.model";

export class WorkingSlotsDialogService {

  /* @ngInject */
  constructor(private $mdDialog, private $log: ILogService,) {
  }


  addWorkingSlotAndOverrideExistingWorkingSlots(workingSlotsCollisions: WorkingSlotEntity[]) {

    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/override-working-slots-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************


        $scope.submit = () => {
          self.$mdDialog.hide(true);
        }
      }
    })
  }
}

angular
  .module('bringoz.admin.working-slots')
  .service('workingSlotsDialogService', WorkingSlotsDialogService);
